import React from 'react';
import ScrollAnimatedItem from '../utils/ScrollAnimatedItem';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faLinkedin,
  faTwitter,
  faInstagram,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.8,
      ease: 'easeOut'
    }
  })
};

const Contact = () => {

  const ContactInfo = [
    {
      href: "mailto:madalavrahulbabu123@gmail.com",
      icon: faEnvelope,
      label: "Email",
    },
    {
      href: "https://github.com/venkataRahulbabu",
      icon: faGithub,
      label: "GitHub",
    },
    {
      href: "https://www.linkedin.com/in/venkata-rahul-babu-madala-94293025b/",
      icon: faLinkedin,
      label: "LinkedIn",
    },
    {
      href: "https://itsrahul.vercel.app/",
      icon: faTwitter,
      label: "Twitter",
    },
    {
      href: "https://itsrahul.vercel.app/",
      icon: faInstagram,
      label: "Instagram",
    },
    {
      href: "https://itsrahul.vercel.app/",
      icon: faFacebook,
      label: "Facebook",
    },
  ];

  return (
    <>
      <ScrollAnimatedItem variants={fadeInUp} triggerOnce={true}>
        <div
          id="contact"
          className="relative p-5 my-3 transition-all select-none"
        >
          <div className="flex flex-col min-[560px]:flex-row items-center justify-between gap-8 transition-all">
            <div className="flex flex-col gap-4 mx-5">
              <h2 className="scroll-m-20 text-4xl font-bold font-sans text-indigo-500 dark:text-white tracking-tight lg:text-5xl">
                Let's Connect
              </h2>
              <div className="text-lg lg:text-xl text-muted-foreground">
                <p className="text-slate-800 dark:text-gray-300 font-medium">
                  Got a question, proposal, project, or want to work together on
                  something?
                </p>
                <a
                  href="mailto:madalavrahulbabu123@gmail.com"
                  className="underline underline-offset-4 hover:text-foreground text-gray-800 dark:text-slate-300 font-medium"
                  rel="noreferrer"
                >
                  Send me an email
                </a>
              </div>
            </div>
            <div className="flex-shrink-0 transition-all">
              <div className="rounded-lg border border-slate-300 dark:border-dashed bg-card text-card-foreground shadow-sm pt-6">
                <div className="p-6 pt-0">
                  <div className="w-full grid gap-4 grid-cols-3">
                    {ContactInfo.map((item, idx) => (
                      <a
                        key={idx}
                        href={item.href}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={item.label}
                        className="inline-flex items-center justify-center rounded-md text-sm dark:text-white bg-slate-200 hover:bg-slate-300 dark:bg-gray-700 dark:hover:bg-gray-800 hover:ring-1 hover:ring-slate-400 font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 h-12 px-4 py-4"
                      >
                        <FontAwesomeIcon icon={item.icon} size="2x" />
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80 transition-all"
            aria-hidden="true"
          >
            <div
              className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tl from-[#ff80b5] opacity-10 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
              style={{
                clipPath:
                  "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
              }}
            />
          </div>
        </div>
      </ScrollAnimatedItem>

      <ScrollAnimatedItem variants={fadeInUp} triggerOnce={true}>
        <footer>
          <div className="mx-5 border-t-2 flex items-center justify-start px-5 transition-all select-none">
            <p className="lg:text-lg text-lg md:font-medium text-gray-700 dark:text-slate-300 my-8 lg:my-6">
              Designed and Developed by
              <a
                className="underline underline-offset-2 transition-colors font-medium bg-gradient-to-tl from-[rgb(90,102,213)] to-[#050dff] bg-clip-text text-transparent dark:text-sky-400 dark:hover:text-slate-300 ml-1"
                href="https://github.com/venkataRahulbabu"
                target="_blank"
                rel="noopener noreferrer"
              >
                Rahul
              </a>
            </p>
          </div>
        </footer>
      </ScrollAnimatedItem>
    </>
  );
};

export default Contact;